import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-4" data-id="element-18">
            About Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary" data-id="element-19">
            Decades of Reliable Service
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="p-8 bg-accent rounded-[10px] text-center" data-id="element-21">
            <div className="text-4xl font-black text-primary mb-4" data-id="element-22">24/7</div>
            <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-23">
              Always Available
            </h3>
            <p className="text-gray-600" data-id="element-24">
              We never sleep so you never have to worry. Rain or shine, day or
              night.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="p-8 bg-accent rounded-[10px] text-center" data-id="element-25">
            <div className="text-4xl font-black text-primary mb-4" data-id="element-26">15k+</div>
            <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-27">
              Rescues Completed
            </h3>
            <p className="text-gray-600" data-id="element-28">
              Thousands of drivers trust us to get them back on the road safely.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="p-8 bg-accent rounded-[10px] text-center" data-id="element-29">
            <div className="text-4xl font-black text-primary mb-4" data-id="element-30">15m</div>
            <h3 className="text-xl font-bold text-secondary mb-2" data-id="element-31">
              Avg. Response Time
            </h3>
            <p className="text-gray-600" data-id="element-32">
              Our zero-queue digital dispatch ensures the fastest arrival times.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}